import type { HeadingProps as _HeadingProps } from "@chakra-ui/react";
import { forwardRef, Heading as _Heading } from "@chakra-ui/react";
export interface HeadingProps extends _HeadingProps {}

export const Heading = forwardRef<HeadingProps, "h2">(({ ...props }, ref) => {
    return <_Heading ref={ref} {...props} />;
});
